export function toTitleCase(string: string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
  }
  
  export function createSelectOptionsFromEnum(Enum: any, titleCase: boolean) {
    let options = [];
  
    for (const key in Enum) {
      options.push({
        label: titleCase ? toTitleCase(Enum[key]) : Enum[key],
        value: key,
      });
    }
  
    return options;
  }
  
  export function createSelectOptions(data: any, label: any, value: any) {
    let selectOptions: any = [];
    data.forEach((option: any) => {
      if (label && value) {
        selectOptions.push({
          label: option[label],
          value: option[value],
        });
      } else {
        selectOptions.push({ label: option, value: option });
      }
    });
  
    return selectOptions;
  }
  